import { useSearchParams, Link } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const QualityGuidelinePhotoPage = () => {
  const [searchParams] = useSearchParams();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">撮影ガイドライン</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              広範囲の反射やブレ、ぼやけ、影、白飛びなどにより商品の状態が確認しづらい画像については、運営側の判断により出品を削除させていただく場合がございます。<br/>
              また、スリーブなどの影響で反射やくすみが発生する場合は、可能な範囲でスリーブを外して撮影していただきますようご協力をお願いいたします。
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">出品削除の対象になる画像例</div>
            </div>
            
            <div className="w-full flex flex-col justify-start items-start gap-[30px]">
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-base font-bold leading-7">・ブレ</div>
                <div className="w-full inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_photo_1.jpg" alt="ブレの例1" />
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_photo_2.jpg" alt="ブレの例2" />
                </div>
              </div>
              
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-base font-bold leading-7">・ぼやけ</div>
                <div className="w-full inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_photo_3.jpg" alt="ぼやけの例1" />
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_photo_4.jpg" alt="ぼやけの例2" />
                </div>
              </div>
              
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-base font-bold leading-7">・白飛び</div>
                <div className="w-full inline-flex justify-start items-center gap-[30px]">
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_photo_5.jpg" alt="白飛びの例1" />
                  <img className="w-1/2 h-auto" src="/images/terms/guideline_photo_6.jpg" alt="白飛びの例2" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default QualityGuidelinePhotoPage;